export default "__VITE_ASSET__CWdc1iH7__"